import { Button } from 'antd';
import styled     from 'styled-components';
import { COLORS } from 'styles/colors';

const RedButton = styled(Button)`
  border-color: ${COLORS.DANGER_RED};
  color: ${COLORS.DANGER_RED};

  &:hover {
    border-color: ${COLORS.DANGER_RED};
    color: ${COLORS.DANGER_RED};
  }
`;

export default RedButton;